import { toast } from "./toast";

const TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 5000,
  // Sin barra de cuenta regresiva (ver ui/Toaster): esta opción por aviso pisa la del contenedor.
  hideProgressBar: true,
  closeOnClick: true,
  // Sin pausa al pasar el mouse (ver ui/Toaster): esta opción por aviso pisa la del contenedor.
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
};

/**
 * Resuelve el tono (color) del toast a partir del 2º argumento.
 * Retro-compatible con la firma vieja:
 *   - `true`            → éxito  (verde)
 *   - ausente / `false` → error  (rojo)
 *   - `"loading"`       → loading
 * Tonos nuevos, vía string explícito:
 *   - `"success"` (verde) · `"error"` (rojo) · `"warning"` (ámbar) ·
 *     `"info"` (azul) · `"loading"`.
 * Usar `"warning"` para avisos/limitaciones (p. ej. "solo en pantalla",
 * "falta endpoint", resultados vacíos) y `"info"` para mensajes neutrales:
 * NO deben pintarse de verde (parece éxito) ni de rojo (parece error).
 */
const resolveTone = (val) => {
  if (val === true) return "success";
  if (typeof val === "string") {
    const tone = val.toLowerCase();
    if (tone === "warn") return "warning";
    if (["success", "error", "warning", "info", "loading"].includes(tone)) {
      return tone;
    }
  }
  return "error";
};

export const showToast = (msg, val) => toast[resolveTone(val)](msg, TOAST_OPTIONS);
